import { useContext } from 'react';
import PropTypes from 'prop-types';
import i18nContext from 'components/i18n-context';
import { CURRENCY, PAYMENT_PROVIDER } from 'components/constants';
import Loader from 'components/Loader';
import Button from 'uikit/Button/Button';
import { CustomDatePicker } from 'uikit/CustomDatePicker';
import { InputDropDown } from 'uikit/InputDropDown/InputDropDown';
import './ReconciliationReportsFiltersBar.scss';

const ReconciliationReportsFiltersBar = ({
  isGeneratingReconciliationReport,
  isInitialized,
  filters,
  handleSetFilters,
  handleGenerateReconciliationReportCsv
}) => {
  const i18n = useContext(i18nContext);
  const currentDate = new Date();

  const transferProviderOptions = Object.keys(PAYMENT_PROVIDER).map((provider) => {
    return {
      key: PAYMENT_PROVIDER[provider].name,
      value: i18n.getMessage('paymentProvider.' + PAYMENT_PROVIDER[provider].name)
    };
  });

  const currencyOptions = Object.keys(CURRENCY).map((status) => {
    return {
      key: CURRENCY[status],
      value: CURRENCY[status]
    };
  });

  return (
    <div className={'reconciliation-reports-filters-wrapper'}>
      <div className={'reconciliation-reports-actions-wrapper'}>
        <div className={'reconciliation-reports-date-range-filters-wrapper'}>
          <div>
            <span>{i18n.getMessage('reconciliationReports.filter.reportDate.label')}</span>
            <CustomDatePicker
              onChange={handleSetFilters}
              name={'reportDate'}
              value={filters.reportDate}
              maxDate={currentDate}
            />
          </div>
        </div>
        <div className={'export-reconciliation-reports-csv-actions-wrapper'}>
          <Button
            className={'reconciliation-reports-button'}
            size={'medium'}
            type={'primary'}
            onClick={handleGenerateReconciliationReportCsv}
            isDisabled={!isInitialized || isGeneratingReconciliationReport}
          >
            {isGeneratingReconciliationReport ? (
              <Loader />
            ) : (
              i18n.getMessage('reconciliationReports.button.reconciliationReportsCsv')
            )}
          </Button>
        </div>
      </div>

      <InputDropDown
        className={'reconciliation-reports-filter-wrapper'}
        label={i18n.getMessage('reconciliationReports.filter.transferProvider.label')}
        name={'transferProvider'}
        value={filters.transferProvider}
        options={transferProviderOptions}
        onChange={handleSetFilters}
        isMulti
      />
      <InputDropDown
        className={'reconciliation-reports-filter-wrapper'}
        label={i18n.getMessage('reconciliationReports.filter.currency.label')}
        name={'currency'}
        value={filters.currency}
        options={currencyOptions}
        onChange={handleSetFilters}
        isMulti
      />
    </div>
  );
};

ReconciliationReportsFiltersBar.propTypes = {
  isGeneratingReconciliationReport: PropTypes.bool,
  isInitialized: PropTypes.bool,
  periodDate: PropTypes.object,
  filters: PropTypes.object,
  totalElements: PropTypes.number,
  handleSetFilters: PropTypes.func,
  handleGenerateReconciliationReportCsv: PropTypes.func
};

export default ReconciliationReportsFiltersBar;
